import React, { useState } from 'react';
import './index.scss';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const CheckMarks = props => {
  const { t, i18n } = useTranslation();
  const [isChecked, setIsChecked] = useState(true);
  let lang = i18n.language;
  return (
    <div className="checkMainContent">
      <div className="checkDataInfo">
        <div className="checkmarkInput">
          <input
            type="checkbox"
            className="dialogComponent"
            name="checkMarks"
            tabIndex="0"
            id="checkMarks"
            onChange={() => {
              setIsChecked(!isChecked);
              props.setCheckMark(!isChecked);
            }}
            checked={isChecked}
          />
          <label
            htmlFor="checkMarks"
            className="checkmark"
            onClick={() => setIsChecked(!isChecked)}
          ></label>
        </div>
        <div className="paraInfo">
          {t('checkmarkData')}&nbsp;"{t('checkmarkUnsubscribe')}"&nbsp;
          {t('checkmarkData1')}&nbsp;
          <a
            className="dialogComponent"
            target="_blank"
            rel="noopener noreferrer"
            href={_.withLocale(lang, '/terms-and-conditions')}
          >
            {t('checkmarkTerms')}
          </a>
          &nbsp;{t('CheckmarkAnd')}&nbsp;
          <a
            className="dialogComponent"
            target="_blank"
            rel="noopener noreferrer"
            href={_.withLocale(lang, '/privacy-policy')}
          >
            {t('checkmarkPolicy')}
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default CheckMarks;
